import { useCallback, useEffect, useRef } from 'react';

type UseDelayedPreventableCallbackOptions = {
	callback: () => void;
	delay: number;
};

export const useDelayedPreventableCallback = ({
	callback,
	delay,
}: UseDelayedPreventableCallbackOptions) => {
	const timeoutRef = useRef<NodeJS.Timeout | null>(null);

	const trigger = useCallback(() => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		timeoutRef.current = setTimeout(() => {
			callback();
			timeoutRef.current = null;
		}, delay);
	}, [callback, delay]);

	const prevent = useCallback(() => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
			timeoutRef.current = null;
		}
	}, []);

	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	return { trigger, prevent };
};
